import React from 'react';
import {
  SYSTEM_PLAYBACK_SPEED_OPTIONS,
  applySystemPlaybackRate,
  readStoredSystemPlaybackRate,
  storeSystemPlaybackRate,
} from '../utils/systemPlaybackSpeed';
import './SystemPlaybackSpeedControl.css';

interface SystemPlaybackSpeedControlProps {
  value: number;
  onChange: (rate: number) => void;
  className?: string;
  disabled?: boolean;
}

const SystemPlaybackSpeedControl: React.FC<SystemPlaybackSpeedControlProps> = ({
  value,
  onChange,
  className = '',
  disabled = false,
}) => (
  <div className={`system-playback-speed ${className}`.trim()} aria-label="System voice playback speed">
    <span className="system-playback-speed-label">Speed</span>
    <div className="system-playback-speed-options">
      {SYSTEM_PLAYBACK_SPEED_OPTIONS.map((opt) => (
        <button
          key={opt.value}
          type="button"
          className={`system-playback-speed-btn${value === opt.value ? ' active' : ''}`}
          disabled={disabled}
          onClick={() => {
            onChange(opt.value);
            storeSystemPlaybackRate(opt.value);
          }}
        >
          {opt.label}
        </button>
      ))}
    </div>
  </div>
);

export function useSystemPlaybackRate(): [number, (rate: number) => void] {
  const [rate, setRate] = React.useState(() => readStoredSystemPlaybackRate());
  const setPlaybackRate = React.useCallback((next: number) => {
    setRate(next);
    storeSystemPlaybackRate(next);
  }, []);
  return [rate, setPlaybackRate];
}

export { applySystemPlaybackRate };

export default SystemPlaybackSpeedControl;
